import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import React, { useEffect, userState } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import SwitchUser from "./SwitchUser";
import { useNavigate } from "react-router-dom";
import { getRoles } from "../../utils/session";
import { Typography, Box } from "@mui/material";

function Banner({ user, auth }) {
  const [open, setOpen] = React.useState(false);
  const [isImpersonated, setIsImpersonated] = React.useState(false);
  const [impersonatedUser, setImpersonatedUser] = React.useState(null);
  const [userId, setUserId] = React.useState(null);
  const [givenName, setGivenName] = React.useState(null);
  const [familyName, setFamilyName] = React.useState(null);
  const [isAdmin, setIsAdmin] = React.useState(false);
  const navigate = useNavigate();

  const handleSwitchUser = () => {
    setOpen(true);
  };
  const handleBecomeAdmin = () => {
    setIsImpersonated(false);
    localStorage.removeItem("impersonated");
    navigate(0);
  };
  useEffect(() => {
    const delegatedUser = localStorage.getItem("impersonated");
    if (delegatedUser) {
      setIsImpersonated(true);
      const decodedUser = JSON.parse(atob(delegatedUser));
      console.log(decodedUser);
      setGivenName(decodedUser.user.firstName);
      setFamilyName(decodedUser.user.lastName);
      setUserId(decodedUser.user.userId);
      localStorage.setItem("userId", decodedUser.user.userId);
    } else {
      setGivenName(user?.profile?.given_name ?? user.profile?.name);
      setFamilyName(user?.profile?.family_name ?? "");
      setUserId(user?.profile?.sub);
      localStorage.setItem("userId", user?.profile?.sub);
    }
    const roles = getRoles(user);
    const adminRole = roles.includes("SEC-IDM-CODES-MG_GBCOSTAMKT1-ADMIN");
    if (adminRole) {
      setIsAdmin(true);
    }
  }, []);



  const handleSignOut = async() => {
    localStorage.removeItem("userId");
    localStorage.removeItem("impersonated");
    try {
      await auth.signoutRedirect();
    } catch (err) {
      console.error('signoutRedirect failed, removing local user as fallback', err);
      auth.removeUser();
      window.location.href = '/';
    }
  };

  const handleClose = () => {
    setOpen(false);
    navigate(0);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        flexWrap: 'wrap',
        px: 3,
        py: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Link to="/">
          <Logo />
        </Link>
      </Box>
      <ButtonGroup sx={{ p: 2, color: 'black', ml: 'auto' }} variant="text" aria-label="text button group">
        {isImpersonated && (
          <Typography sx={{ ml: 1, mt: 1, textDecoration: 'underline', textDecorationColor: 'skyblue' }}>
            Impersonating as:
          </Typography>
        )}
        <Button>
          {givenName} {familyName} ({userId})
        </Button>
        {!isImpersonated && isAdmin && <Button onClick={handleSwitchUser}>Switch User</Button>}
        {isImpersonated && <Button onClick={handleBecomeAdmin}>Become Admin</Button>}
        <Button onClick={handleSignOut}>Logout</Button>
      </ButtonGroup>
      <SwitchUser open={open} handleClose={handleClose} />
    </Box>
  );
}

export default Banner;
